/**
 * The last user who signed in on this browser (name, email, photo), kept across logout so the
 * login page's dashboard preview can show their own account. Only display details are stored.
 */
const LAST_USER_KEY = 'last_signed_in_user';

export const getLastSignedInUser = () => {
  try {
    const data = localStorage.getItem(LAST_USER_KEY);
    const user = data ? JSON.parse(data) : null;
    return user && (user.name || user.email) ? user : null;
  } catch {
    return null;
  }
};

export const setLastSignedInUser = ({ name, email, photo }) => {
  if (!name && !email) return;
  try {
    localStorage.setItem(
      LAST_USER_KEY,
      JSON.stringify({ name: name || '', email: email || '', photo: photo || '' })
    );
  } catch {}
};
